export const getAreSelectedSuppliersDirty = state => state?.selectedSuppliers?.dirty || false
export const getSelectedSuppliers = state => state?.selectedSuppliers?.suppliers || []
